import { type IEntitiesStore } from 'entities/EntitiesExport'

export async function getAppData(entities: IEntitiesStore) {
  const {
    usersStore,
    subscriptionStore,
    userSettingsStore,
    organizationSettingsStore,
    organizationStore,
    numbersStore,
    featureFlagsStore,
    complianceStore,
    billingStore,
    userPermissionsStore,
    multiOrganizationStore,
    integrationsStore,
    configStore,
    rcsStore,
  } = entities

  await Promise.all([
    usersStore.init(),
    usersStore.fetchUsersBusinessHours(),
    userPermissionsStore.fetchUserPermissions(),
    usersStore.initUsersOrganization(),

    subscriptionStore.init(),
    configStore.init(),
    userSettingsStore.fetchUsersSettings(),
    organizationSettingsStore.fetchOrganizationSettings(),
    organizationStore.init(),
    numbersStore.fetchOrganizationNumber(),
    numbersStore.fetchNumberVendorIntegrations(),
    numbersStore.fetchNumbers(),
    billingStore.fetchAutorecharge(),
    billingStore.applyCoupon(),
    billingStore.fetchBillingAreaCodes(),
    billingStore.fetchBillingStates(),
    featureFlagsStore.fetchFeatureFlags(),
    multiOrganizationStore.fetchMultiOrganizations(),
    complianceStore.fetchSummary(),
    complianceStore.fetchOrganizationBusinessProfile(),
    complianceStore.fetchComplianceServicesList(),
    complianceStore.fetchOrganizationTollFree(),
    complianceStore.fetchOrganizationUKCompliance(),
    integrationsStore.fetchIntegrations(),
    rcsStore.init(),
  ])
}
